import { render, staticRenderFns } from "./CvatDataTable.vue?vue&type=template&id=592f9006&scoped=true"
import script from "./CvatDataTable.vue?vue&type=script&lang=js"
export * from "./CvatDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592f9006",
  null
  
)

export default component.exports